module.exports = __webpack_public_path__ + "./assets/outlook_logo.png";